"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScriptLoader;
(function (ScriptLoader) {
    ScriptLoader.loadScript = function (options) {
        var script;
        script = document.createElement('script');
        script.src = options.src;
        if (options.id) {
            script.id = options.id;
        }
        if (Boolean(options.async)) {
            script.async = options.async;
        }
        if (Boolean(options.defer)) {
            script.defer = options.defer;
        }
        if (options.onload) {
            script.onload = options.onload;
        }
        document.body.appendChild(script);
    };
    ScriptLoader.LoadScriptAsync = function (options) {
        return new Promise(function (resolve, reject) {
            var script;
            if (document.getElementById(options.id))
                resolve();
            script = document.createElement('script');
            script.src = options.src;
            script.id = options.id;
            script.addEventListener('load', resolve);
            script.addEventListener('error', function () { return reject('Error loading script.'); });
            script.addEventListener('abort', function () { return reject('Script loading aborted.'); });
            document.body.appendChild(script);
        });
    };
})(ScriptLoader = exports.ScriptLoader || (exports.ScriptLoader = {}));
//# sourceMappingURL=scriptLoader.js.map